module.exports = __webpack_public_path__ + "static/media/stroke2.9d91b5aa.png";